import { ReactElement } from 'react';

import s from './FieldError.module.css';

export interface FieldErrorProps {
  touched: boolean | undefined;
  errors: string | undefined;
}

const FieldError = ({ touched, errors }: FieldErrorProps): ReactElement | null => {
  if (!errors || !touched) return null;

  return <span className={s.error}>{errors}</span>;
};

export default FieldError;
